/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamExamitemidApproveEditorQueryResponse,
  GetApiV1ExamExamitemidApproveEditorPathParams,
  GetApiV1ExamExamitemidApproveEditor401,
  GetApiV1ExamExamitemidApproveEditor404,
  GetApiV1ExamExamitemidApproveEditor500,
} from "../../types/examQuestionLibraryController/GetApiV1ExamExamitemidApproveEditor.ts";

function getGetApiV1ExamExamitemidApproveEditorUrl(
  examItemId: GetApiV1ExamExamitemidApproveEditorPathParams["examItemId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/${examItemId}/approve-editor` as const,
  };
  return res;
}

/**
 * @description Retorna os dados necessários para o editor de aprovação de uma questão da biblioteca, incluindo o status atual, justificativa e se o usuário logado possui permissão de aprovação. **(Requer Authorization para autenticação)**
 * @summary Obter dados do editor de aprovação de questão (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:examItemId/approve-editor}
 */
export async function getApiV1ExamExamitemidApproveEditor(
  examItemId: GetApiV1ExamExamitemidApproveEditorPathParams["examItemId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamExamitemidApproveEditorQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamExamitemidApproveEditor401
      | GetApiV1ExamExamitemidApproveEditor404
      | GetApiV1ExamExamitemidApproveEditor500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamExamitemidApproveEditorUrl(examItemId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
